
interface ReviewProps {
  author: string;
  reviewBody: string;
  datePublished: string;
  rating?: number;
}

interface ItemReviewedProps {
  name: string;
  type: "NursingHome" | "Organization";
}

/**
 * Generate Review schema for testimonials
 */
export function generateReviewSchema(reviews: ReviewProps[], itemReviewed: ItemReviewedProps) {
  return {
    "@context": "https://schema.org",
    "@type": "Review",
    "itemReviewed": {
      "@type": itemReviewed.type,
      "name": itemReviewed.name
    },
    "review": reviews.map(review => ({
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": review.author
      },
      "reviewBody": review.reviewBody,
      "datePublished": review.datePublished,
      ...(review.rating && {
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": review.rating,
          "bestRating": "5",
          "worstRating": "1"
        }
      })
    }))
  };
}
